var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 9.16683C7.30086 9.16683 9.16634 7.30135 9.16634 5.00016C9.16634 2.69898 7.30086 0.833496 4.99967 0.833496C2.69849 0.833496 0.833008 2.69898 0.833008 5.00016C0.833008 7.30135 2.69849 9.16683 4.99967 9.16683Z",
    stroke: "#F2C94C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.87533V7.08366M5 2.91699V5.41699V2.91699Z",
    stroke: "#F2C94C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8a0d3e6a854c89ed8f4c1ffb6e905f57.svg";
export { ForwardRef as ReactComponent };